export default __webpack_public_path__ + "static/media/btn_menu.414dcf2d.svg";